<template>
    <div class="user-account-type">
        <b-tag v-if="user.accountType === 'client'" rounded>Cliente</b-tag>
        <b-tag type="is-success" v-if="user.accountType === 'admin'" rounded>Administrador</b-tag>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "userAccountType",
        
        computed: {
            ...mapGetters(["user"])
        }
    }
</script>

<style scoped>

</style>